var STORAGE_PREFIX = "sep24:callbacks";
var getStorageKey = function (scopeType, scopeValue) {
    return "".concat(STORAGE_PREFIX, ":").concat(scopeType, ":").concat(scopeValue);
};
var getScopeEntries = function (scope) {
    var entries = [];
    if (scope.transactionId) {
        entries.push(["tx", scope.transactionId]);
    }
    if (scope.sessionToken) {
        entries.push(["session", scope.sessionToken]);
    }
    if (scope.authToken) {
        entries.push(["auth", scope.authToken]);
    }
    return entries;
};
var hasWindow = function () { return typeof window !== "undefined"; };
export var storeSep24Callbacks = function (scope, callbacks) {
    if (!hasWindow())
        return;
    var payload = {};
    if (callbacks.callback) {
        payload.callback = callbacks.callback;
    }
    if (callbacks.onChangeCallback) {
        payload.onChangeCallback = callbacks.onChangeCallback;
    }
    if (!payload.callback && !payload.onChangeCallback) {
        return;
    }
    for (var _i = 0, _a = getScopeEntries(scope); _i < _a.length; _i++) {
        var _b = _a[_i], scopeType = _b[0], scopeValue = _b[1];
        window.localStorage.setItem(getStorageKey(scopeType, scopeValue), JSON.stringify(payload));
    }
};
export var readSep24Callbacks = function (scope) {
    if (!hasWindow())
        return {};
    for (var _i = 0, _a = getScopeEntries(scope); _i < _a.length; _i++) {
        var _b = _a[_i], scopeType = _b[0], scopeValue = _b[1];
        var raw = window.localStorage.getItem(getStorageKey(scopeType, scopeValue));
        if (!raw)
            continue;
        try {
            var parsed = JSON.parse(raw);
            return {
                callback: parsed.callback,
                onChangeCallback: parsed.onChangeCallback,
            };
        }
        catch (_c) {
            window.localStorage.removeItem(getStorageKey(scopeType, scopeValue));
        }
    }
    return {};
};
